import type { RefObject, MouseEvent as ReactMouseEvent } from 'react';

export function isMouseOutsideElement(
  event: ReactMouseEvent,
  ref: RefObject<HTMLElement | null>,
): boolean {
  const isNodeType = event.relatedTarget instanceof Node;
  if (!isNodeType) {
    return true;
  }

  const relatedTarget = event.relatedTarget as Node;
  const isOutsideRelatedTarget =
    !ref.current?.contains(relatedTarget) &&
    ref.current !== event.relatedTarget;

  return isOutsideRelatedTarget;
}
